// extracted by mini-css-extract-plugin
export var editInput = "_fy-0";
export var editInputCompact = "_fy-2";
export var editInputLarge = "_fy-1";
export var editInputSmall = "_fy-3";